import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getProductByID,
  clearProductItem,
  deleteProductByID,
  publishProductNoUpdate,
  emailProductRequest,
} from '../../actions/productActions';
import Spinner from '../common/Spinner';
import Navbar from '../layout/Navbar';
import isEmpty from '../../validation/is-empty';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import options from '../common/Options';
import Banner from '../common/Banner';
import { withRouter } from 'react-router-dom';
import DOMPurify from 'dompurify';
import Phone from '../common/Phone';
import TextField from '../common/TextField';
import TextAreaField from '../common/TextAreaField';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import 'moment/locale/fi';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import ReactTooltip from 'react-tooltip';

const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userEmail: '',
      userPhone: '',
      message: '',
      from: undefined,
      to: undefined,
      searchPosio: false,
      emailSuccess: false,
    };
    this.handleFromChange = this.handleFromChange.bind(this);
    this.handleToChange = this.handleToChange.bind(this);
  }

  componentDidMount() {
    document.title = this.props.intl.formatMessage({
      id: 'company.titleLoading',
    });
    this.props.clearProductItem();
    this.props.getProductByID(this.props.match.params.id);
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (this.props.product !== prevProps.product) {
      const { ...product } = this.props.product.product_item;
      this.setState((prevState) => ({
        ...prevState,
        ...product,
      }));

      if (this.props.product.emailSuccess) {
        this.setState({
          userEmail: '',
          userPhone: '',
          message: '',
          from: undefined,
          to: undefined,
          searchPosio: false,
        });
      }
    }
    if (this.state.titleFi !== '' && this.state.titleFi !== undefined) {
      document.title = `${this.props.locale.lang === 'fi'
        ? this.state.titleFi
        : isEmpty(this.state.titleEn)
          ? this.state.titleFi
          : this.state.titleEn
        } ${this.props.intl.formatMessage({
          id: 'product.title',
        })}`;
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.errors !== state.errors) {
      return { errors: props.errors };
    }
    return null;
  }

  onDeleteClick(e) {
    e.preventDefault();
    let message = '';
    if (this.props.locale.lang === 'en') message = 'Are you sure?';
    else message = 'Oletko varma?';
    if (window.confirm(message)) {
      this.props.deleteProductByID(this.state._id, this.props.history);
    }
  }

  showFromMonth() {
    const { from, to } = this.state;
    if (!from) {
      return;
    }
    if (moment(to).diff(moment(from), 'months') < 2) {
      this.to.getDayPicker().showMonth(from);
    }
  }

  handleFromChange(from) {
    this.setState({ from });
  }

  handleToChange(to) {
    this.setState({ to }, this.showFromMonth);
  }

  onEmailSubmit = (e) => {
    e.preventDefault();
    const userData = {
      locale: this.props.locale.lang,
      userEmail: this.state.userEmail,
      userPhone: this.state.userPhone,
      message: this.state.message,
      companyEmail: this.state.contacts
        ? this.state.company.email
        : this.state.email,
      id: this.props.product.product_item.user,
      company_id: this.state.company._id,
      product_id: this.state._id,
      product_name:
        this.props.locale.lang === 'fi'
          ? this.state.titleFi
          : isEmpty(this.state.titleEn)
            ? this.state.titleFi
            : this.state.titleEn,
      from: formatDate(this.state.from, 'LL', this.props.locale.lang),
      to: formatDate(this.state.to, 'LL', this.props.locale.lang),
    };
    if (this.state.from && this.state.to && this.state.searchPosio) {
      openInNewTab(
        `https://posioshop.com/varaus/?h=&r=&mode=&d1=${formatDate(
          this.state.from,
          'YYYY-MM-DD'
        )}&d2=${formatDate(this.state.to, 'YYYY-MM-DD')}`
      );
    }

    this.props.emailProductRequest(userData);
  };

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    const { product_item, loading, emailSuccess } = this.props.product;
    const admin = this.props.auth.user;
    const { errors } = this.state;
    const FORMAT = 'LL';
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };

    let productContent;

    if (product_item === null || loading) {
      productContent = (
        <div style={{ marginTop: '30vh', marginBottom: '30vh' }}>
          <Spinner />
        </div>
      );
    } else {
      productContent = (
        <div>
          <Helmet>
            <meta name="og:image" content={this.state.photo} />
          </Helmet>
          <Banner
            pageName={
              this.props.locale.lang === 'fi'
                ? this.state.titleFi
                : isEmpty(this.state.titleEn)
                  ? this.state.titleFi
                  : this.state.titleEn
            }
          />
          <div id="content" className="section-padding">
            <div className="container">
              <div className="row">
                {/* Product Info Start */}
                <div className="col-lg-8 col-md-12 col-xs-12">
                  <div className="products-bg">
                    <div
                      className="image-big image-center"
                      style={{ backgroundImage: `url(${this.state.photo})` }}
                    ></div>
                    <div className="content">
                      <div className="inner-box property-dsc">
                        {isEmpty(this.state.titleFi) ? null : (
                          <h1 className="company-title">
                            {this.props.locale.lang === 'fi'
                              ? this.state.titleFi
                              : isEmpty(this.state.titleEn)
                                ? this.state.titleFi
                                : this.state.titleEn}
                          </h1>
                        )}
                        {isEmpty(this.state.categoryFi) ? null : (
                          <p className="company-subtitle">
                            {this.props.locale.lang === 'fi'
                              ? this.state.categoryFi
                              : isEmpty(this.state.categoryEn)
                                ? this.state.categoryFi
                                : this.state.categoryEn}
                          </p>
                        )}
                      </div>
                      <div className="inner-box property-dsc">
                        <h4 className="desc-title">
                          <FormattedMessage id="product.ProductDescription" />
                        </h4>

                        {isEmpty(this.state.descriptionFi) ? null : (
                          <p
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                this.props.locale.lang === 'fi'
                                  ? this.state.descriptionFi
                                  : isEmpty(this.state.descriptionEn)
                                    ? this.state.descriptionFi
                                    : this.state.descriptionEn
                              ),
                            }}
                          />
                        )}
                      </div>
                      <div className="inner-box short-info">
                        <ul className="additional-details">
                          {isEmpty(this.state.company) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="dashboard.company" />
                              </strong>
                              <span>
                                <Link to={`/company/${this.state.company._id}`}>
                                  {this.state.company.name}
                                </Link>
                              </span>
                            </li>
                          )}
                          {isEmpty(this.state.category) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="dashboard.category" />
                              </strong>
                              <span>
                                {
                                  options.find(
                                    (element) =>
                                      element.value === this.state.category
                                  ).label
                                }
                              </span>
                            </li>
                          )}
                          {isEmpty(this.state.labelFi) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="dashboard.label" />
                              </strong>
                              <span>
                                {this.props.locale.lang === 'fi'
                                  ? this.state.labelFi
                                  : isEmpty(this.state.labelEn)
                                    ? this.state.labelFi
                                    : this.state.labelEn}
                              </span>
                            </li>
                          )}
                          {isEmpty(this.state.languagesFi) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="dashboard.languages" />
                              </strong>
                              <span>
                                {this.props.locale.lang === 'fi'
                                  ? this.state.languagesFi
                                  : isEmpty(this.state.languagesEn)
                                    ? this.state.languagesFi
                                    : this.state.languagesEn}
                              </span>
                            </li>
                          )}
                          {isEmpty(this.state.outfitFi) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="dashboard.outfit" />
                              </strong>
                              <span>
                                {this.props.locale.lang === 'fi'
                                  ? this.state.outfitFi
                                  : isEmpty(this.state.outfitEn)
                                    ? this.state.outfitFi
                                    : this.state.outfitEn}
                              </span>
                            </li>
                          )}
                          {isEmpty(this.state.duration) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="dashboard.duration" />
                              </strong>
                              <span>
                                {this.state.duration}{' '}
                                <FormattedMessage id="dashboard.hours" />
                              </span>
                            </li>
                          )}
                          {isEmpty(this.state.groupsize) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="dashboard.groupsize" />
                              </strong>
                              <span>{this.state.groupsize}</span>
                            </li>
                          )}
                          {isEmpty(this.state.priceFi) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="dashboard.price" />
                              </strong>
                              <span>
                                {this.props.locale.lang === 'fi'
                                  ? this.state.priceFi
                                  : isEmpty(this.state.priceEn)
                                    ? this.state.priceFi
                                    : this.state.priceEn}
                              </span>
                            </li>
                          )}
                          {isEmpty(this.state.placeFi) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="dashboard.place" />
                              </strong>
                              <span>
                                {this.props.locale.lang === 'fi'
                                  ? this.state.placeFi
                                  : isEmpty(this.state.placeEn)
                                    ? this.state.placeFi
                                    : this.state.placeEn}
                              </span>
                            </li>
                          )}
                          {isEmpty(this.state.startdate) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="dashboard.startdate" />
                              </strong>
                              <span>{`${formatDate(
                                this.state.startdate,
                                FORMAT,
                                this.props.locale.lang
                              )}`}</span>
                            </li>
                          )}
                          {isEmpty(this.state.enddate) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="dashboard.enddate" />
                              </strong>
                              <span>{`${formatDate(
                                this.state.enddate,
                                FORMAT,
                                this.props.locale.lang
                              )}`}</span>
                            </li>
                          )}
                        </ul>
                        {isEmpty(this.state.buylink) ? null : (
                          <div className="mt-4">
                            <a
                              className="btn btn-common"
                              href={this.state.buylink}
                            >
                              <FormattedMessage id="product.buylink" />
                            </a>
                          </div>
                        )}
                        <div className="inner-box short-info">
                          <div class="share-buttons">
                            <a
                              href={`http://www.facebook.com/sharer.php?u=${encodeURIComponent(
                                window.location.href
                              )}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src="https://simplesharebuttons.com/images/somacro/facebook.png"
                                alt="Facebook"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*Sidebar*/}
                <aside
                  id="sidebar"
                  className="col-lg-4 col-md-12 col-xs-12 right-sidebar"
                >
                  <div className="widget mt3">
                    <div className="sidebar-title">
                      <FormattedMessage id="product.contacts" />
                    </div>
                    <ul className="additional-details">
                      {this.state.contacts ? (
                        <div>
                          {/* Company's contants */}
                          {isEmpty(this.state.company.phone) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="product.phone" />
                              </strong>
                              <span>
                                {Phone(
                                  this.state.company.phone,
                                  this.props.locale.lang
                                )}
                              </span>
                            </li>
                          )}
                          {isEmpty(this.state.company.email) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="product.email" />
                              </strong>
                              <span>{this.state.company.email}</span>
                            </li>
                          )}
                          {isEmpty(this.state.company.address) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="product.address" />
                              </strong>
                              <span>
                                {' '}
                                <a
                                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                    this.state.company.address
                                  )}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {this.state.company.address}
                                </a>{' '}
                                <i className="lni-map-marker" />
                              </span>
                            </li>
                          )}
                          {isEmpty(this.state.company.website) ? null : (
                            <li>
                              <strong>
                                <FormattedMessage id="product.website" />
                              </strong>
                              <span>
                                <a href={this.state.company.website}>
                                  {this.state.company.website.replace(
                                    /(^\w+:|^)\/\//,
                                    ''
                                  )}
                                </a>
                              </span>
                            </li>
                          )}
                        </div>
                      ) : (
                          <div>
                            {/* Custom contants */}
                            {isEmpty(this.state.phone) ? null : (
                              <li>
                                <strong>
                                  <FormattedMessage id="product.phone" />
                                </strong>
                                <span>
                                  {Phone(
                                    this.state.phone,
                                    this.props.locale.lang
                                  )}
                                </span>
                              </li>
                            )}
                            {isEmpty(this.state.email) ? null : (
                              <li>
                                <strong>
                                  <FormattedMessage id="product.email" />
                                </strong>
                                <span>{this.state.email}</span>
                              </li>
                            )}
                            {isEmpty(this.state.address) ? null : (
                              <li>
                                <strong>
                                  <FormattedMessage id="product.address" />
                                </strong>
                                <span>
                                  {' '}
                                  <a
                                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                      this.state.address
                                    )}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {this.state.address}
                                  </a>{' '}
                                  <i className="lni-map-marker" />
                                </span>
                              </li>
                            )}
                            {isEmpty(this.state.website) ? null : (
                              <li>
                                <strong>
                                  <FormattedMessage id="product.website" />
                                </strong>
                                <span>
                                  <a href={this.state.website}>
                                    {this.state.website.replace(
                                      /(^\w+:|^)\/\//,
                                      ''
                                    )}
                                  </a>
                                </span>
                              </li>
                            )}
                          </div>
                        )}
                    </ul>
                    {/* Social Media */}

                    {this.state.company && (
                      <div>
                        {isEmpty(this.state.company.social.twitter) &&
                          isEmpty(this.state.company.social.facebook) &&
                          isEmpty(this.state.company.social.instagram) ? null : (
                            <div className="widget mt-3">
                              <div className="sidebar-title mb-2">
                                <FormattedMessage id="company.SocialMedia" />
                              </div>

                              <ul className="social-icons">
                                {isEmpty(
                                  this.state.company.social.twitter
                                ) ? null : (
                                    <li>
                                      <a
                                        className="twitter"
                                        href={this.state.company.social.twitter}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <i className="lni-twitter-filled" />
                                      </a>
                                    </li>
                                  )}
                                {isEmpty(
                                  this.state.company.social.facebook
                                ) ? null : (
                                    <li>
                                      <a
                                        className="facebook"
                                        href={this.state.company.social.facebook}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <i className="lni-facebook-filled" />
                                      </a>
                                    </li>
                                  )}
                                {isEmpty(
                                  this.state.company.social.instagram
                                ) ? null : (
                                    <li>
                                      <a
                                        className="instagram"
                                        href={this.state.company.social.instagram}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <i className="lni-instagram-filled" />
                                      </a>
                                    </li>
                                  )}
                                {isEmpty(
                                  this.state.company.social.youtube
                                ) ? null : (
                                    <li>
                                      <a
                                        className="youtube"
                                        href={this.state.company.social.youtube}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <i className="lni-youtube" />
                                      </a>
                                    </li>
                                  )}
                              </ul>
                            </div>
                          )}
                      </div>
                    )}

                    {this.state.company && (
                      <div>
                        <ReactTooltip place="right" multiline={true} />
                        <div className="widget mt-5">
                          <div className="agent-inner">
                            <div className="agent-title">
                              <div className="agent-details mt-2 ml-0">
                                <h3>{this.state.company.name}</h3>
                                {isEmpty(this.state.phone) ||
                                  isEmpty(this.state.company.phone) ? null : (
                                    <span>
                                      <i className="lni-phone-handset" />
                                      {Phone(
                                        this.state.contacts
                                          ? this.state.company.phone
                                          : this.state.phone,
                                        this.props.locale.lang
                                      )}
                                    </span>
                                  )}
                              </div>
                            </div>
                            <form onSubmit={this.onEmailSubmit}>
                              <label>
                                <FormattedMessage id="product.email" />
                                <span className="text-danger">&nbsp;*</span>
                              </label>
                              <FormattedMessage id="company.YourEmail">
                                {(YourEmail) => (
                                  <TextField
                                    placeholder={YourEmail}
                                    name="userEmail"
                                    type="text"
                                    value={this.state.userEmail}
                                    onChange={this.onChange}
                                    error={errors.userEmail}
                                  />
                                )}
                              </FormattedMessage>

                              <label>
                                <FormattedMessage id="product.phone" />
                                <span className="text-danger">&nbsp;*</span>
                              </label>
                              <FormattedMessage id="company.YourPhone">
                                {(YourPhone) => (
                                  <TextField
                                    placeholder={YourPhone}
                                    name="userPhone"
                                    type="text"
                                    value={this.state.userPhone}
                                    onChange={this.onChange}
                                    error={errors.userPhone}
                                  />
                                )}
                              </FormattedMessage>

                              <label>
                                <FormattedMessage id="product.when" />
                                <FormattedMessage id="product.whenexplanation">
                                  {(whenexplanation) => (
                                    <img
                                      src="img/information.png"
                                      className="info"
                                      alt=""
                                      data-tip={whenexplanation}
                                    />
                                  )}
                                </FormattedMessage>
                              </label>
                              <div className="form-group two-dates">
                                <div className="InputFromTo">
                                  <DayPickerInput
                                    onDayChange={this.handleFromChange}
                                    value={from}
                                    formatDate={formatDate}
                                    format={'L'}
                                    parseDate={parseDate}
                                    placeholder={`${formatDate(
                                      new Date(),
                                      'L',
                                      this.props.locale.lang
                                    )}`}
                                    dayPickerProps={{
                                      selectedDays: [from, { from, to }],
                                      locale: this.props.locale.lang,
                                      localeUtils: MomentLocaleUtils,
                                      disabledDays: {
                                        after: new Date(this.state.enddate),
                                        before: new Date(this.state.startdate),
                                      },
                                      toMonth: to,
                                      modifiers,
                                      numberOfMonths: 2,
                                      onDayClick: () =>
                                        this.to.getInput().focus(),
                                    }}
                                  />
                                </div>{' '}
                                —{' '}
                                <div className="InputFromTo InputFromTo-to">
                                  <DayPickerInput
                                    ref={(el) => (this.to = el)}
                                    onDayChange={this.handleToChange}
                                    value={to}
                                    formatDate={formatDate}
                                    format={'L'}
                                    parseDate={parseDate}
                                    placeholder={`${formatDate(
                                      new Date(),
                                      'L',
                                      this.props.locale.lang
                                    )}`}
                                    dayPickerProps={{
                                      selectedDays: [from, { from, to }],
                                      locale: this.props.locale.lang,
                                      localeUtils: MomentLocaleUtils,
                                      disabledDays: {
                                        after: new Date(this.state.enddate),
                                        before: new Date(this.state.startdate),
                                      },
                                      modifiers,
                                      month: from,
                                      fromMonth: from,
                                      numberOfMonths: 2,
                                    }}
                                  />
                                </div>
                              </div>

                              <label>
                                <FormattedMessage id="product.message" />
                                <span className="text-danger">&nbsp;*</span>
                              </label>
                              <FormattedMessage id="company.YourMessage">
                                {(YourMessage) => (
                                  <TextAreaField
                                    placeholder={YourMessage}
                                    name="message"
                                    type="text"
                                    required={true}
                                    value={this.state.message}
                                    onChange={this.onChange}
                                    error={errors.message}
                                  />
                                )}
                              </FormattedMessage>
                              {/* 
                              {this.state.productType === 'Accommodation' && (
                                <div>
                                  <label>
                                    <FormattedMessage id="product.searchPosio" />
                                  </label>
                                  <input
                                    name="searchPosio"
                                    type="checkbox"
                                    disabled={
                                      !(this.state.to && this.state.from)
                                    }
                                    style={{
                                      marginLeft: '10px',
                                      marginTop: '8px',
                                      position: 'absolute',
                                    }}
                                    checked={this.state.searchPosio}
                                    onChange={() => {
                                      this.setState((prevState) => ({
                                        searchPosio: !prevState.searchPosio,
                                      }));
                                    }}
                                  />
                                </div>
                              )}
                              */}

                              {emailSuccess && (
                                <p className="text-success text-center">
                                  <FormattedMessage id="company.emailSuccess" />
                                </p>
                              )}
                              {!emailSuccess && (
                                <button className="btn btn-common fullwidth mt-4">
                                  <FormattedMessage id="company.SendMessage" />
                                </button>
                              )}
                            </form>
                          </div>
                        </div>
                      </div>
                    )}

                    {!admin.isAdmin ? null : (
                      <div>
                        <div className="text-center mt-5">
                          <Link
                            to={`/edit-product/${this.props.match.params.id}`}
                            className="btn btn-common mt-2"
                          >
                            <FormattedMessage id="product.EditThisProduct" />
                          </Link>
                        </div>
                        {this.state.isreviewed ? null : (
                          <div className="text-center mt-2">
                            <button
                              onClick={() => {
                                this.props.publishProductNoUpdate(
                                  this.state._id,
                                  this.props.history
                                );
                                this.setState({ isreviewed: true });
                              }}
                              className="btn btn-success mt-2"
                            >
                              <FormattedMessage id="review.Publish" />
                            </button>
                          </div>
                        )}
                        <div className="text-center mt-2">
                          <button
                            onClick={this.onDeleteClick.bind(this)}
                            className="btn btn-border-danger mt-2"
                          >
                            <FormattedMessage id="editproduct.deleteproduct" />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </aside>
                {/*End sidebar*/}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <Navbar />
        {productContent}
      </div>
    );
  }
}

Product.propTypes = {
  auth: PropTypes.object.isRequired,
  getProductByID: PropTypes.func.isRequired,
  clearProductItem: PropTypes.func.isRequired,
  emailRequest: PropTypes.func,
  product: PropTypes.object.isRequired,
  locale: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  product: state.product,
  locale: state.locale,
  errors: state.errors,
});

export default withRouter(
  connect(mapStateToProps, {
    getProductByID,
    clearProductItem,
    deleteProductByID,
    publishProductNoUpdate,
    emailProductRequest,
  })(injectIntl(Product))
);
